/* eslint-disable jsx-a11y/label-has-associated-control */
import type { VoidFunctionComponent } from 'react';

import { Action, ResourceType, useHasPermission } from '../../../../../../../../shared/permissions';
import Toggle from '../../../../../../../generic/Toggle';

import styles from './MakeDefaultToggle.module.less';

type Props = {
  onToggle: (isChecked: boolean) => void;
};

/**
 * A toggle to allow users to set the current settings as the default for all reports.
 */
const MakeDefaultToggle: VoidFunctionComponent<Props> = ({ onToggle }) => {
  const hasPermission = useHasPermission();
  const canSetDefault = hasPermission({
    action: Action.Edit,
    resourceType: ResourceType.OrganizationGeneralSettings,
  });

  if (!canSetDefault) {
    return null;
  }

  return (
    <div className={styles.defaultToggle}>
      <Toggle onChange={onToggle} id="makeDefault" />
      <label htmlFor="makeDefault" className={styles.defaultToggleLabel}>
        Make Default
      </label>
    </div>
  );
};

export default MakeDefaultToggle;
